import { useaxios } from "../../../utils/useaxios";
export default (from, to) => initDispatch => clear => settable_type => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    // initDispatch({ type: 'loadingTrue' });
    useaxios('report/broke/summary_broke.php', { from, to }).then((res) => {
        if (res == "Unauthorized") {
            clear();
            return;
        } else if (res == "request_failed") {
            alert('no internet connection');
            return false;
        } else if (res.status == "ok") {
            initDispatch({ type: 'setsummary_broke_report', payload: { summary_broke_report: res.total_price_broke, summary_gift_report: res.total_price_gift } });
            settable_type("summary_broke_report");
        }
        // setloading(false);
    });
}